/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreatePaymentMethodRequest,
  CreatePaymentMethodResult,
  DisplayRepeatCashTransactionsForPerson,
  DisplayStripePublishableKey,
  GetPaymentMethodResult,
  ListPaymentMethodParams,
  ListPaymentMethodResultPagedResults,
  ProcessStripeEventParams,
  SetDefaultPaymentMethodResult,
  UpdatePaymentMethodRequest,
  UpdatePaymentMethodResult
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Attempts to create a new PaymentMethod for the current PlatformUser. If it there are no PaymentMethods, the new one will be set as the default.
 */
export const createPaymentMethod = (
    createPaymentMethodRequest: CreatePaymentMethodRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CreatePaymentMethodResult>(
      {url: `/api/v1/payment-methods`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPaymentMethodRequest, signal
    },
      options);
    }




export const getCreatePaymentMethodMutationKey = () => ['createPaymentMethod'] as const;

export const getCreatePaymentMethodMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentMethod>>, TError,CreatePaymentMethodMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof createPaymentMethod>>, TError,CreatePaymentMethodMutationVariables, TContext> => {

const mutationKey = getCreatePaymentMethodMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPaymentMethod>>, CreatePaymentMethodMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPaymentMethod(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof createPaymentMethod>>>
    export type CreatePaymentMethodMutationBody = CreatePaymentMethodRequest
    export type CreatePaymentMethodMutationError = ErrorType<unknown>
    export type CreatePaymentMethodMutationVariables = {data: CreatePaymentMethodRequest}

    /**
 * @summary Attempts to create a new PaymentMethod for the current PlatformUser. If it there are no PaymentMethods, the new one will be set as the default.
 */
export const useCreatePaymentMethod = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentMethod>>, TError,CreatePaymentMethodMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPaymentMethod>>,
        TError,
        CreatePaymentMethodMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePaymentMethodMutationOptions(options));
    }
    /**
 * @summary List all PaymentMethods attached to the current PlatformUser
 */
export const listPaymentMethod = (
    params?: ListPaymentMethodParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ListPaymentMethodResultPagedResults>(
      {url: `/api/v1/payment-methods`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListPaymentMethodQueryKey = (params?: ListPaymentMethodParams,) => {
    return [
    `/api/v1/payment-methods`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPaymentMethodQueryOptions = <TData = Awaited<ReturnType<typeof listPaymentMethod>>, TError = ErrorType<unknown>>(params?: ListPaymentMethodParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethod>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPaymentMethodQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPaymentMethod>>> = ({ signal }) => listPaymentMethod(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethod>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPaymentMethodQueryResult = NonNullable<Awaited<ReturnType<typeof listPaymentMethod>>>
export type ListPaymentMethodQueryError = ErrorType<unknown>


/**
 * @summary List all PaymentMethods attached to the current PlatformUser
 */

export function useListPaymentMethod<TData = Awaited<ReturnType<typeof listPaymentMethod>>, TError = ErrorType<unknown>>(
 params?: ListPaymentMethodParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethod>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPaymentMethodQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Updates PaymentMethod attached to the current PlatformUser
 */
export const updatePaymentMethod = (
    updatePaymentMethodRequest: UpdatePaymentMethodRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<UpdatePaymentMethodResult>(
      {url: `/api/v1/payment-methods`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePaymentMethodRequest, signal
    },
      options);
    }




export const getUpdatePaymentMethodMutationKey = () => ['updatePaymentMethod'] as const;

export const getUpdatePaymentMethodMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentMethod>>, TError,UpdatePaymentMethodMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePaymentMethod>>, TError,UpdatePaymentMethodMutationVariables, TContext> => {

const mutationKey = getUpdatePaymentMethodMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePaymentMethod>>, UpdatePaymentMethodMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updatePaymentMethod(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof updatePaymentMethod>>>
    export type UpdatePaymentMethodMutationBody = UpdatePaymentMethodRequest
    export type UpdatePaymentMethodMutationError = ErrorType<unknown>
    export type UpdatePaymentMethodMutationVariables = {data: UpdatePaymentMethodRequest}

    /**
 * @summary Updates PaymentMethod attached to the current PlatformUser
 */
export const useUpdatePaymentMethod = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentMethod>>, TError,UpdatePaymentMethodMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePaymentMethod>>,
        TError,
        UpdatePaymentMethodMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePaymentMethodMutationOptions(options));
    }
    /**
 * @summary Deletes a PaymentMethod attached to the current PlatformUser
 */
export const deletePaymentMethod = (
    paymentMethodId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/payment-methods/${paymentMethodId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeletePaymentMethodMutationKey = () => ['deletePaymentMethod'] as const;

export const getDeletePaymentMethodMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePaymentMethod>>, TError,DeletePaymentMethodMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePaymentMethod>>, TError,DeletePaymentMethodMutationVariables, TContext> => {

const mutationKey = getDeletePaymentMethodMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePaymentMethod>>, DeletePaymentMethodMutationVariables> = (props) => {
          const {paymentMethodId} = props ?? {};

          return  deletePaymentMethod(paymentMethodId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof deletePaymentMethod>>>

    export type DeletePaymentMethodMutationError = ErrorType<unknown>
    export type DeletePaymentMethodMutationVariables = {paymentMethodId: string}

    /**
 * @summary Deletes a PaymentMethod attached to the current PlatformUser
 */
export const useDeletePaymentMethod = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePaymentMethod>>, TError,DeletePaymentMethodMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePaymentMethod>>,
        TError,
        DeletePaymentMethodMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePaymentMethodMutationOptions(options));
    }
    /**
 * @summary Gets a payment method by id.
 */
export const getPaymentMethodById = (
    paymentMethodId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GetPaymentMethodResult>(
      {url: `/api/v1/payment-methods/${paymentMethodId}`, method: 'GET', signal
    },
      options);
    }




export const getGetPaymentMethodByIdQueryKey = (paymentMethodId: string,) => {
    return [
    `/api/v1/payment-methods/${paymentMethodId}`
    ] as const;
    }


export const getGetPaymentMethodByIdQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentMethodById>>, TError = ErrorType<unknown>>(paymentMethodId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethodById>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentMethodByIdQueryKey(paymentMethodId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentMethodById>>> = ({ signal }) => getPaymentMethodById(paymentMethodId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: paymentMethodId !== null && paymentMethodId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethodById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPaymentMethodByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentMethodById>>>
export type GetPaymentMethodByIdQueryError = ErrorType<unknown>


/**
 * @summary Gets a payment method by id.
 */

export function useGetPaymentMethodById<TData = Awaited<ReturnType<typeof getPaymentMethodById>>, TError = ErrorType<unknown>>(
 paymentMethodId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethodById>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPaymentMethodByIdQueryOptions(paymentMethodId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Sets a PaymentMethod to be the default for the current PlatformUser
 */
export const setDefaultPaymentMethod = (
    paymentMethodId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SetDefaultPaymentMethodResult>(
      {url: `/api/v1/payment-methods/default/${paymentMethodId}`, method: 'POST', signal
    },
      options);
    }




export const getSetDefaultPaymentMethodMutationKey = () => ['setDefaultPaymentMethod'] as const;

export const getSetDefaultPaymentMethodMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultPaymentMethod>>, TError,SetDefaultPaymentMethodMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof setDefaultPaymentMethod>>, TError,SetDefaultPaymentMethodMutationVariables, TContext> => {

const mutationKey = getSetDefaultPaymentMethodMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDefaultPaymentMethod>>, SetDefaultPaymentMethodMutationVariables> = (props) => {
          const {paymentMethodId} = props ?? {};

          return  setDefaultPaymentMethod(paymentMethodId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetDefaultPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof setDefaultPaymentMethod>>>

    export type SetDefaultPaymentMethodMutationError = ErrorType<unknown>
    export type SetDefaultPaymentMethodMutationVariables = {paymentMethodId: string}

    /**
 * @summary Sets a PaymentMethod to be the default for the current PlatformUser
 */
export const useSetDefaultPaymentMethod = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultPaymentMethod>>, TError,SetDefaultPaymentMethodMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setDefaultPaymentMethod>>,
        TError,
        SetDefaultPaymentMethodMutationVariables,
        TContext
      > => {
      return useMutation(getSetDefaultPaymentMethodMutationOptions(options));
    }
    /**
 * @summary Returns the current user's RepeatCash wallet transactions for the platform.
 */
export const getRepeatCashTransactions = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayRepeatCashTransactionsForPerson>(
      {url: `/api/v1/repeat-cash/transactions`, method: 'GET', signal
    },
      options);
    }




export const getGetRepeatCashTransactionsQueryKey = () => {
    return [
    `/api/v1/repeat-cash/transactions`
    ] as const;
    }


export const getGetRepeatCashTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getRepeatCashTransactions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactions>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRepeatCashTransactionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepeatCashTransactions>>> = ({ signal }) => getRepeatCashTransactions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRepeatCashTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getRepeatCashTransactions>>>
export type GetRepeatCashTransactionsQueryError = ErrorType<unknown>


/**
 * @summary Returns the current user's RepeatCash wallet transactions for the platform.
 */

export function useGetRepeatCashTransactions<TData = Awaited<ReturnType<typeof getRepeatCashTransactions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactions>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRepeatCashTransactionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Gets the platform's Stripe publishable key for checkout and public financing messaging.
 */
export const getPublishableKey = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayStripePublishableKey>(
      {url: `/api/v1/stripe-keys/publishable-key`, method: 'GET', signal
    },
      options);
    }




export const getGetPublishableKeyQueryKey = () => {
    return [
    `/api/v1/stripe-keys/publishable-key`
    ] as const;
    }


export const getGetPublishableKeyQueryOptions = <TData = Awaited<ReturnType<typeof getPublishableKey>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublishableKey>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublishableKeyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublishableKey>>> = ({ signal }) => getPublishableKey(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublishableKey>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublishableKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getPublishableKey>>>
export type GetPublishableKeyQueryError = ErrorType<unknown>


/**
 * @summary Gets the platform's Stripe publishable key for checkout and public financing messaging.
 */

export function useGetPublishableKey<TData = Awaited<ReturnType<typeof getPublishableKey>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublishableKey>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublishableKeyQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Processes Stripe Webhook Events
 */
export const processStripeEvent = (
    params?: ProcessStripeEventParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<boolean>(
      {url: `/api/v1/stripe/webhook`, method: 'POST',
        params, signal
    },
      options);
    }




export const getProcessStripeEventMutationKey = () => ['processStripeEvent'] as const;

export const getProcessStripeEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processStripeEvent>>, TError,ProcessStripeEventMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof processStripeEvent>>, TError,ProcessStripeEventMutationVariables, TContext> => {

const mutationKey = getProcessStripeEventMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processStripeEvent>>, ProcessStripeEventMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  processStripeEvent(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProcessStripeEventMutationResult = NonNullable<Awaited<ReturnType<typeof processStripeEvent>>>

    export type ProcessStripeEventMutationError = ErrorType<unknown>
    export type ProcessStripeEventMutationVariables = {params?: ProcessStripeEventParams}

    /**
 * @summary Processes Stripe Webhook Events
 */
export const useProcessStripeEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processStripeEvent>>, TError,ProcessStripeEventMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof processStripeEvent>>,
        TError,
        ProcessStripeEventMutationVariables,
        TContext
      > => {
      return useMutation(getProcessStripeEventMutationOptions(options));
    }
